import axios from 'axios';
import { getOpenOrders, getSupplierOrders, getInvoicedAmount, getProjectInvoicing } from './projectData';

const API_KEY = process.env.REACT_APP_OPENAI_API_KEY;
const BASE_URL = 'https://api.openai.com/v1/chat/completions';

export const askChatGPT = async (messages) => {
  try {
    if (!API_KEY) {
      throw new Error('Falta configurar REACT_APP_OPENAI_API_KEY para usar el asistente.');
    }
    const response = await axios.post(
      BASE_URL,
      {
        model: 'gpt-4',
        messages,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${API_KEY}`,
        },
      }
    );

    return response.data.choices[0].message.content;
  } catch (error) {
    console.error('Error communicating with ChatGPT API:', error);
    throw new Error('Failed to fetch response from ChatGPT.');
  }
};

export const askChatGPTWithData = async (query) => {
  let dataResponse = '';

  if (query.includes('ordenes de compra abiertas')) {
    const openOrders = getOpenOrders();
    dataResponse = `Hay ${openOrders.length} órdenes de compra abiertas.`;
  } else if (query.includes('ordenes tiene el proveedor')) {
    const supplierId = query.match(/proveedor (\w+)/)?.[1];
    if (supplierId) {
      const supplierOrders = getSupplierOrders(supplierId);
      dataResponse = `El proveedor tiene ${supplierOrders.length} órdenes.`;
    } else {
      dataResponse = 'Por favor, especifica el proveedor.';
    }
  } else if (query.includes('cuanto tenemos facturado')) {
    const invoicedAmount = getInvoicedAmount();
    dataResponse = `El monto total facturado es ${invoicedAmount}.`;
  } else if (query.includes('facturado al proyecto')) {
    const projectId = query.match(/proyecto (\w+)/)?.[1];
    if (projectId) {
      const projectInvoicing = getProjectInvoicing(projectId);
      dataResponse = `El monto facturado al proyecto es ${projectInvoicing}.`;
    } else {
      dataResponse = 'Por favor, especifica el proyecto.';
    }
  }

  const messages = [
    { role: 'system', content: 'You are a helpful assistant for analyzing project data.' },
    { role: 'user', content: query },
    { role: 'assistant', content: dataResponse },
  ];

  return askChatGPT(messages);
};
